import React, { useEffect, useState } from "react";
import {
  createMuiTheme,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Typography } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core";
import AddToListModal from "../Components/FormGenerator/addToListModal";
import { TOGGLE_GROWING_LIST_POPUP } from "../Redux/actions";
import { useDispatch } from "react-redux";

const theme = createMuiTheme({
  overrides: {
    // root: {
    //     color: 'green',
    //     '& label.Mui-focused': {
    //         color: 'green',
    //     },
    //     '& .MuiInput-underline:after': {
    //         borderBottomColor: 'green',
    //     },
    //     '& .MuiOutlinedInput-root': {
    //         '& fieldset': {
    //             borderColor: 'red',
    //         },
    //         '&:hover fieldset': {
    //             borderColor: 'yellow',
    //         },
    //         '&.Mui-focused fieldset': {
    //             borderColor: 'green',
    //         },
    //     },
    // },
  },
});
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      lineHeight: "22px",
      padding: "9.5px 14px",
      // fontFamily: "Open Sans",
      // color: 'green',
      // '& label.Mui-focused': {
      //     color: 'green',
      // },
      // '& .MuiInput-underline:after': {
      //     borderBottomColor: 'green',
      // },
      // '& .MuiOutlinedInput-root': {
      //     '& fieldset': {
      //         borderColor: 'red',
      //     },
      //     '&:hover fieldset': {
      //         borderColor: 'yellow',
      //     },
      //     '&.Mui-focused fieldset': {
      //         borderColor: 'green',
      //     },
      // },
    },
    formControl: {
      width: "100%",
      "label + &": {
        marginTop: "2px",
      },
      "& p": {
        marginTop: "4px",
        marginLeft: "0px",
      },
    },

    whiteColor: {
      color: "red",
    },
  })
);
function CustomSelect(props: any) {
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = React.useState("");
  // const [showModal, setShowModal] = useState(false);
  const [postData, setPostData] = useState({});
  const dispatch = useDispatch();

  const handleChange = (event: any) => {
    if (event.target.value == "Add New") {
      // setShowModal(true)
      dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: true });
      props.addNewHandler(props.addNewFlag, true, props);
    } else {
      setSelectedValue(event.target.value);
      var dataIndex = props.dataIndex == undefined ? 0 : props.dataIndex;
      props.parentcall({
        value: event.target.value,
        id: props.id,
        dataIndex: dataIndex,
        targetId: event.target.id,
      });
    }
  };
  useEffect(() => {
    props.defaultValue != undefined && setSelectedValue(props.defaultValue);
  }, [props]);

  return (
    <FormControl
      variant={props.variant}
      className={classes.formControl}
      error={props.error}
    >
      <Select
        placeholder={props.placeholder}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
        {...props}
        value={selectedValue}
        onChange={handleChange}
        classes={{
          root: classes.root,
        }}
      >
        {!props?.hideLable ? (
          <MenuItem value={selectedValue == "0" ? selectedValue : ""}>
            <Typography
              variant="h2"
              component="span"
              style={{ color: "#808080", display: "block" }}
            >
              {props.labelText || "Select Role"}
            </Typography>
          </MenuItem>
        ) : null}
        {props?.itemArr?.map((option: any, index: any) => {
          return (
            <MenuItem value={option}>
              <Typography variant="h2">
                {typeof option === "string" &&
                option?.toLowerCase() === "programme price"
                  ? "Program price"
                  : option}
              </Typography>
            </MenuItem>
          );
        })}
        {props.addNewFlag && (
          <MenuItem key="Add New" value="Add New">
            <Typography variant="h2">+ Add New</Typography>
          </MenuItem>
        )}
      </Select>
      {/* {
                props.addNewFlag && showModal &&
                <AddToListModal type="partner_profiles" postData={{...props}} />
            } */}

      {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
    </FormControl>
  );
}

export default CustomSelect;
